var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAplicationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 20.6352V34.0625C26.25 35.9609 24.7617 37.5 22.8945 37.5H8.35938C6.48828 37.5 5 35.9609 5 34.0625V13.4375C5.00533 12.5275 5.36921 11.6562 6.01271 11.0127C6.65621 10.3692 7.52746 10.0053 8.4375 10H15.7906C16.0451 10.0004 16.297 10.0514 16.5316 10.1501C16.7662 10.2489 16.9788 10.3933 17.157 10.575L25.6844 19.2469C26.0472 19.6179 26.2502 20.1162 26.25 20.6352Z",
    stroke: "#2544EE",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 10V18.4375C15.6319 19.0155 15.8646 19.5679 16.2733 19.9767C16.6821 20.3854 17.2345 20.6181 17.8125 20.625H26.25",
    stroke: "#2544EE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10V5.9375C13.7553 5.02746 14.1192 4.15622 14.7627 3.51271C15.4062 2.86921 16.2775 2.50533 17.1875 2.5H24.5312C24.7872 2.50036 25.0405 2.55134 25.2766 2.65003C25.5127 2.74871 25.727 2.89315 25.907 3.075L34.4344 11.7469C34.7969 12.1139 35.0002 12.6091 35 13.125V26.5625C35 28.4609 33.5117 30 31.6445 30H26.875",
    stroke: "#2544EE",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 2.5V10.9375C24.3819 11.5155 24.6146 12.0679 25.0233 12.4767C25.4321 12.8854 25.9845 13.1181 26.5625 13.125H35",
    stroke: "#2544EE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAplicationIcon);
export default __webpack_public_path__ + "static/media/aplicationIcon.6f01d64344a89ba0047f2be34de8d750.svg";
export { ForwardRef as ReactComponent };